import { type FC, useCallback, useEffect } from "react";

import { serverFetchLatestPublications } from "api/api-server-publishing";
import { CourseView } from "components/materials/home/admin/content/courses/CourseView";
import { TermsView } from "components/materials/home/admin/content/terms/TermsView";
import { type SectionViewOption } from "components/menus/SectionViewOptionMenu";
import { storeApi, useAppDispatch, useAppSelector } from "store/index";
import { selectLastSectionViewOption } from "store/selectors";
import { localStateActions } from "store/slices/local";
import { isCCMEnabled } from "utils/waffle-flags";

export const AdminSectionsView: FC = () => {
  const dispatch = useAppDispatch();
  const sectionViewOption = useAppSelector(selectLastSectionViewOption) || "course";

  useEffect(() => {
    storeApi.course_groupings.list();
    if (isCCMEnabled()) {
      serverFetchLatestPublications();
    }
  }, []);

  const handleOptionChange = useCallback(
    (option: SectionViewOption) => {
      dispatch(localStateActions.setLastSectionViewOption(option));
    },
    [dispatch],
  );

  return sectionViewOption === "course" ? (
    <CourseView onOptionChange={handleOptionChange} />
  ) : (
    <TermsView onOptionChange={handleOptionChange} />
  );
};
